import { atom } from "jotai";
import { EDaoMode } from "~/_enums/EDaoMode";

type TGlobal = {
  joinedDaoSubdomains: string[];
  memberSubscriptionId: string | null;
  mode: EDaoMode | null;
  userId: string | null;
};

const initialGlobal: TGlobal = {
  joinedDaoSubdomains: [],
  memberSubscriptionId: null,
  mode: null,
  userId: null,
};

export const globalAtom = atom<TGlobal>(initialGlobal);

export const writeSetGlobalJoinedDaoSubdomainsAtom = atom(
  null,
  (_, set, joinedDaoSubdomains: TGlobal["joinedDaoSubdomains"]) =>
    set(globalAtom, (prev) => ({ ...prev, joinedDaoSubdomains })),
);

export const writeSetGlobalMemberSubscriptionIdAtom = atom(
  null,
  (_, set, memberSubscriptionId: TGlobal["memberSubscriptionId"]) =>
    set(globalAtom, (prev) => ({ ...prev, memberSubscriptionId })),
);

export const writeSetGlobalModeAtom = atom(
  null,
  (_, set, mode: TGlobal["mode"]) =>
    set(globalAtom, (prev) => ({ ...prev, mode })),
);

export const writeSetGlobalUserIdAtom = atom(
  null,
  (_, set, userId: TGlobal["userId"]) =>
    set(globalAtom, (prev) => ({ ...prev, userId })),
);
